import { render } from "./IconWeb.vue?vue&type=template&id=10600556"
import script from "./IconWeb.vue?vue&type=script&lang=js"
export * from "./IconWeb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__